/*
 This method formats the address parts into a single string.
 It has been refactored here to address the replication of this method in various places.
 */
const formatAddress = ({ buildingName, unitType, unitNumber, streetNumber, streetName, suburb }) => {
    const buildingNamePart = buildingName ? `${buildingName}, ` : '';
    const unitTypePart = unitType ? `${unitType} ` : '';
    const unitNumberPart = unitNumber ? `${unitNumber} / ` : '';
    return `${buildingNamePart}${unitTypePart}${unitNumberPart}${streetNumber} ${streetName}, ${suburb}`;
};

export { formatAddress };
